/* tslint:disable */
/* eslint-disable */
export enum WorkChatMemberSourceEnum {
  Auto = 'auto',
  Manual = 'manual'
}
